import shajs from 'sha.js';

export default function sha256(value) {
  return shajs('sha256').update(value.toLowerCase()).digest('hex');
}
